module.exports = __webpack_public_path__ + "static/media/lego-balloon.825566c9.png";